import { Component, Input, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  FormGroup,
} from '@angular/forms';
import { InputField } from '../../../core/models/input-field';

@Component({
  selector: 'app-chips',
  templateUrl: './chips.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class ChipsComponent implements OnInit {
  /**
   * * General
   * @errors Form control errors
   * @specificFormGroup Set custom form group
   */
  errors: any = {};
  specificFormGroup: FormGroup;
  /**
   * * Inputs
   * @options Configuration for this form field
   * @customFormGroup Used when you want to use this component without form-builder
   */
  @Input() options: InputField;
  @Input() customFormGroup: any;

  constructor(public controlContainer: ControlContainer) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    if (this.options.fieldFormGroup || this.options.fieldFormGroup == '') {
      this.specificFormGroup = this.getSpecificFormGroup(
        this.options.fieldFormGroup
      );
    } else {
      this.specificFormGroup = this.customFormGroup;
    }
    if (this.options.fieldFormGroup == '') {
      this.specificFormGroup = this.customFormGroup;
    }
    // this.specificFormGroup = this.options.fieldFormGroup !== '' ? this.getSpecificFormGroup(this.options.fieldFormGroup) : this.customFormGroup;
  }

  /* ====================================
  *                HELPERS
  ======================================= */

  onChange(event: Event) {
    const formGroup = this.controlContainer.control as FormGroup;

    if (this.customFormGroup && this.options.fieldFormGroup !== undefined) {
      this.errors =
        this.customFormGroup.controls[this.options.formControlName].errors;
    } else if (
      this.customFormGroup &&
      (this.options.fieldFormGroup || this.options.fieldFormGroup == '')
    ) {
      this.errors = formGroup.controls[this.options.formControlName].errors;
    } else {
      this.errors = formGroup.controls[this.options.formControlName].errors;
    }
  }

  getSpecificFormGroup(formGroupPath: string) {
    return <FormGroup>this.customFormGroup.get(formGroupPath);
  }
}
